export type ServerUnpublishedSummaryLike = {
  hasUnpublished?: boolean
  counts?: { vehicleDrafts?: number; inventoryDrafts?: number }
  configDrafts?: Record<string, { exists?: boolean } | undefined>
}

function isServerSummaryClean(summary: ServerUnpublishedSummaryLike | null | undefined): boolean {
  if (!summary) return false
  if (summary.hasUnpublished !== false) return false

  const vehicleDrafts = Number(summary.counts?.vehicleDrafts ?? 0)
  const inventoryDrafts = Number(summary.counts?.inventoryDrafts ?? 0)
  if (vehicleDrafts > 0 || inventoryDrafts > 0) return false

  const drafts = summary.configDrafts || {}
  for (const k of Object.keys(drafts)) {
    if (drafts[k]?.exists === true) return false
  }
  return true
}

/**
 * Decide whether we should clear the persisted JAMS "unpublished" marker.
 *
 * Rationale:
 * - Server summary is authoritative for drafts (ConfigDraft, VehicleDraft, inventory drafts).
 * - The JAMS marker can become stale and should not resurrect "ghost" changes.
 * - But we must NOT clear during a user-initiated publish while processing is in-flight,
 *   because the marker is also used for reconcile/snapshot semantics.
 */
export function shouldClearPersistedUnpublished(params: {
  serverSummary: ServerUnpublishedSummaryLike | null | undefined
  hasPendingPublish: boolean
  isPublishInFlight: boolean
}): boolean {
  const { serverSummary, hasPendingPublish, isPublishInFlight } = params
  if (hasPendingPublish || isPublishInFlight) return false
  return isServerSummaryClean(serverSummary)
}

